import React from 'react';
import { Star, StarHalf } from 'lucide-react';
interface RatingStarsProps {
  rating: number; // 0 to 5
  max?: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function RatingStars({
  rating,
  max = 5,
  size = 'md',
  className = ''
}: RatingStarsProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  const stars = [];
  for (let i = 1; i <= max; i++) {
    if (rating >= i) {
      // Full star
      stars.push(<Star key={i} className={`${sizeClasses[size]} fill-yellow-400 text-yellow-400`} aria-hidden="true" data-id="element-160" />);
    } else if (rating >= i - 0.5) {
      // Half star
      stars.push(<div key={i} className="relative" data-id="element-161">
          <Star className={`${sizeClasses[size]} text-gray-200 fill-gray-200`} aria-hidden="true" data-id="element-162" />
          <div className="absolute top-0 left-0 overflow-hidden w-1/2" data-id="element-163">
            <StarHalf className={`${sizeClasses[size]} text-yellow-400 fill-yellow-400`} aria-hidden="true" data-id="element-164" />
          </div>
        </div>);
    } else {
      // Empty star
      stars.push(<Star key={i} className={`${sizeClasses[size]} text-gray-200 fill-gray-200`} aria-hidden="true" data-id="element-165" />);
    }
  }
  return <div className={`flex items-center space-x-1 ${className}`} aria-label={`Bewertung: ${rating} von ${max} Sternen`} data-id="element-166">
      {stars}
    </div>;
}